import React from 'react';
import { Helmet } from 'react-helmet-async';

const HomeSEO = () => {
  // Base URL for canonical links and OG URLs
  const baseUrl = 'https://blends.co.il';
  
  // Primary image for social sharing
  const ogImage = 'https://d5l8cb2ud43ux.cloudfront.net/blends-banner_m4tbic.jpg';
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>פשוט מדביקים תמונות לקיר | Blends</title>
      <meta name="description" content="מסגרות לתמונות שנדבקות לקיר ללא מסמרים. תמונות קיר ממוסגרות באיכות גבוהה, מסגרות בהדבקה לקיר, משלוחים עד הבית. הפכו את הקיר שלכם לסיפור עם תמונות משפחתיות." />
      <meta name="keywords" content="תמונות קיר, תמונות להדבקה על הקיר, תמונות לתליה על הקיר, תמונות על הקיר, תמונה על הקיר, מסגרות קיר, מסגרות לתמונות, מסגרות נדבקות לקיר, מסגרות ללא מסמרים, הדפסת תמונות, תמונות משפחה, קיר תמונות, עיצוב קיר, עיצוב תמונה, עיצוב תמונות" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Hebrew" />
      <link rel="canonical" href={baseUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={baseUrl} />
      <meta property="og:title" content="פשוט מדביקים תמונות לקיר | Blends" />
      <meta property="og:description" content="מסגרות לתמונות שנדבקות לקיר ללא מסמרים. הדפסת תמונות באיכות גבוהה, מסגרות מעוצבות לקיר, משלוחים עד הבית." />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:site_name" content="Blends" />
    </Helmet>
  );
};

export default HomeSEO;
